import * as React from "react";
import { Tab } from "semantic-ui-react";
import { LogView } from "../../logView/LogView";
import {ImportSimTransportOrderOutputTable} from "./ImportSimTransportOrderOutputTable";
import {ImportSimOutput} from "./ImportSimOutput";
import {ImportSimResponseFiles} from "./ImportSimResponseFiles";
import {clampTabIndex} from "../../../context/TabSession";

const panes = [
    { menuItem: 'Output', render: props => <Tab.Pane><ImportSimOutput outputTO={props.outputTO} selectedFileName={props.selectedFileName}/></Tab.Pane> },
    { menuItem: 'TransportOrders', render: props => <Tab.Pane><ImportSimTransportOrderOutputTable outputTO={props.outputTO}/></Tab.Pane> },
    { menuItem: 'Logs', render: props => <Tab.Pane><LogView
            query={props.xRequestId}
            origin={"importSim"}
            initialTimespan={null}
            responseLogs={null}
        /></Tab.Pane> },
    { menuItem: 'Response Files', render: props => <Tab.Pane><ImportSimResponseFiles outputTO={props.outputTO}/></Tab.Pane> },
]

const ImportSimOutputTabMenu = props => <Tab
    className="flexTab"
    {...props = props}
    panes={panes}
    defaultActiveIndex={clampTabIndex(props.context.tabSession.importSimOutputTab, panes)}
    onTabChange={(_, data) => {
        props.context.setSingleTabSession("importSimOutputTab", data.activeIndex)
    }}
/>

export default ImportSimOutputTabMenu